module.exports = new __parcel__URL__("GT_P_2_008_mobile.fd32cf75.json").toString();